export default __webpack_public_path__ + "static/media/the-lovers-pressed@2x.ad22c1dc.png";